import { useQuery } from "@tanstack/react-query";
import { fetchAnalysisConfigs } from "../api/fetch-analysis-configs";

export const ANALYSIS_CONFIGS_QUERY_KEY = "analysisConfigs";

export function useAnalysisConfigs(branchUid: string | undefined, versionId?: number) {
  return useQuery({
    queryKey: [ANALYSIS_CONFIGS_QUERY_KEY, branchUid, versionId],
    queryFn: () => fetchAnalysisConfigs(branchUid!, versionId),
    enabled: Boolean(branchUid),
  });
}
